import React, { useState } from 'react';
import { Typography, Box, Paper, Avatar } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import proxelera from "../../images/proxelera.png"
import { ColorCode } from '../../styles/colors';
import { Collapse, Button, } from '@mui/material';
import { customStyles } from "../../styles/tableStyle"
import DHSPolicy from "./DHSPolicy";
const PolicyReminder = () => {
  let combinedStyles = Object.assign(customStyles.hyperlink, { textAlign: 'left' })
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen(!open);
  };
  return (
    <Paper elevation={1} sx={{
      p: 2, alignItems: 'center', display: 'flex', flexDirection: 'column'
    }}>
      <Avatar style={{ background: ColorCode.warning, padding: 2, justifyContent: 'center' }}>
        <WarningIcon style={{ color: 'white' }} />
      </Avatar>
      <Typography variant="subtitle1" color={ColorCode.hint} style={{ marginLeft: 1 }}>
        This application does not store your uploaded data. Files are used only for processing and then permanently deleted.
      </Typography>


      <Button 
        onClick={handleToggle}
        style={{alignSelf:'start'}}>
        {open ? 'Hide' : 'Read'} DHL Policy
      </Button>
      <Collapse in={open}>
        <DHSPolicy />
      </Collapse>

    </Paper>
  );
};

export default PolicyReminder;